// extracted by css-extract-rspack-plugin
export default {"rangeLink":"_193ab9ac"};